var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed inset-0 flex items-center justify-center h-full z-60"},[_c('div',{staticClass:"bg-darken-5 fixed inset-0 z-50"}),_c('router-view',{staticClass:"z-60"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }